import React, { useState } from "react";

const TeamButton = (props) => {
  const [hover, setHover] = useState(false);

  const clickHandler = () => {
    props.setURL(props.DisplayName);
    props.setActiveButton(props.id);
    props.executeScroll();
  };

  const getResizedImageURL = (url, width, height) => {
    return `${url}?width=${width}&height=${height}&quality=80&fit=cover`;
  };

  const renderOffices = () => {
    return props.Offices && props.Offices.map((office, index) => (
      <span key={index}>
        {office}{index < props.Offices.length - 1 ? ', ' : ''}
      </span>
    ));
  };

  return (
    <div className="col-lg-3 col-md-4 col-sm-6 col-12 mb-4">
      <div 
        className={`card ${props.active ? 'border border-success border-4' : ''}`}
        onClick={clickHandler}
        style={{
          cursor: 'pointer',
          borderRadius: '8px',
          background: '#404040',
          transition: 'transform 0.3s ease, box-shadow 0.3s ease',
          overflow: 'hidden',
          position: 'relative',
          width: '100%',
          height: '400px', // Fixed card height
          boxShadow: 'rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'translate(-5px, -5px)';
          e.currentTarget.style.boxShadow = 'rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 8px 15px 12px';
          setHover(true);
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'translate(0, 0)';
          e.currentTarget.style.boxShadow = 'rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px';
          setHover(false);
        }}
      >
        {/* Provider photo taking up most of the card */}
        <div style={{ height: '340px' }}>
          <img
            src={getResizedImageURL(props.PictureLink, 300, 450)}
            alt={props.DisplayName}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'center 30%'
            }}
          />
        </div>
        
        {/* Hover overlay */}
        {hover && (
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            color: '#ffffff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '1.5rem',
            zIndex: 5,
            borderRadius: '8px'
          }}>
            Read Biography
          </div>
        )}
        
        {/* Gray bar with name and location */}
        <div style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          padding: '12px 10px',
          textAlign: 'center',
          background: 'linear-gradient(to bottom, rgba(70, 70, 70, 1) 0%, rgba(50, 50, 50, 1) 100%)',
          height: '60px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center'
        }}>
          {/* Name in bold */}
          <h5 style={{
            color: '#ffffff',
            fontWeight: '600',
            fontSize: '1.1rem',
            marginBottom: '2px',
            textShadow: '1px 1px 2px rgba(0,0,0,0.5)'
          }}>
            {props.DisplayName}
          </h5>
          
          {/* Location in smaller text */}
          <p style={{
            color: '#e0e0e0',
            fontSize: '0.85rem',
            marginBottom: '0',
            fontWeight: '300'
          }}>
            {renderOffices()}
          </p>
        </div>
      </div>
    </div>
  );
};

export default TeamButton;